import type { FreeTextSearch } from '@/api/contracts/dataModel';

export interface FreeTextSearchClientState {
  term: string;
  columnFields: string[];
}

export function buildFreeTextSearchPayload (
  state: FreeTextSearchClientState | null | undefined
): FreeTextSearch | undefined {
  if (state == null) return undefined;
  const term = state.term.trim();
  if (term.length === 0 || state.columnFields.length === 0) return undefined;
  return {
    term,
    searchInColumns: state.columnFields.map((columnName) => ({
      tableAliasOrName: '',
      columnName
    }))
  };
}

/**
 * Lager FreeTextSearch-payload fra en ren term-string. Tom liste i `searchInColumns`
 * lar BE auto-fylle fra IsSearchable-kolonnene (`FreeTextSearchMergeHelper.AutoFillSearchableColumns`).
 */
export function buildFreeTextFromTerm (term: string): FreeTextSearch | null {
  const trimmed = term.trim();
  if (trimmed.length === 0) return null;
  return { term: trimmed, searchInColumns: [] };
}
